import React, { useEffect, useState } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { useTimezone } from '../hooks/useTimezone';
import { getTimezoneAbbreviation } from '../utils/timezone.utils';

const formatInZone = (date, timeZone, options) => {
    try {
        return new Intl.DateTimeFormat('en-US', { ...options, timeZone }).format(date);
    } catch {
        return new Intl.DateTimeFormat('en-US', options).format(date);
    }
};

const NavbarClock = () => {
    const timezone = useTimezone();
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const timer = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    const time = formatInZone(now, timezone, { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
    const date = formatInZone(now, timezone, { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' });
    const abbreviation = getTimezoneAbbreviation(timezone, now);

    return (
        <Popup
            trigger={(
                <div
                    className="navbar-clock"
                    aria-label={`Current time ${time} ${abbreviation}`}
                    style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', lineHeight: 1.15, cursor: 'default' }}
                >
                    <Icon name="clock outline" style={{ margin: 0, opacity: 0.8 }} />
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '3px' }}>
                        <span style={{ fontWeight: 600, fontSize: '0.95rem', fontVariantNumeric: 'tabular-nums' }}>
                            {time} <span style={{ fontWeight: 500, opacity: 0.8, fontSize: '0.8rem' }}>{abbreviation}</span>
                        </span>
                        <span style={{ fontSize: '0.72rem', opacity: 0.7 }}>{date}</span>
                    </div>
                </div>
            )}
            content={`Timezone: ${timezone}. Change it in Settings.`}
            position="bottom right"
            size="small"
            inverted
        />
    );
};

export default NavbarClock;
